class CountdownTimer extends HTMLElement {
  constructor() {
    super();

    this.section = this;

    this.second = 1000;
    this.minute = this.second * 60;
    this.hour = this.minute * 60;
    this.day = this.hour * 24;

    this.postEventHeading = this.section.querySelector('#wct_headline').dataset.postEventHeading;
    this.postEventSubheading = this.section.querySelector('#wct_subhead').dataset.postEventSubheading;

    this.clock = null;

    this.init();

    if (Shopify.designMode) {
      document.addEventListener('shopify:section:load', (event) => {
        clearInterval(this.clock);
        this.clock = null;
        this.init();
      });
    }
  }

  init() {
    let targetEventTime = this.section.querySelector('[data-target-event-time]').dataset.targetEventTime;
    targetEventTime = new Date(this.section.querySelector('[data-target-event-time]').dataset.targetEventTime);
    let countDownTime = new Date(targetEventTime).getTime();

    this.clock = setInterval(
      function () {
        this.updateClock(this.section, targetEventTime, countDownTime);
      }.bind(this),
      0
    );
  }

  updateClock(section, targetEventTime, countDownTime) {
    let now = new Date().getTime();

    let distance = countDownTime - now;

    (section.querySelector('#wct_days').innerText = Math.floor(distance / section.day)),
      (section.querySelector('#wct_hours').innerText = Math.floor((distance % section.day) / section.hour)),
      (section.querySelector('#wct_minutes').innerText = Math.floor((distance % section.hour) / section.minute)),
      (section.querySelector('#wct_seconds').innerText = Math.floor((distance % section.minute) / section.second));

    //do something later when date is reached
    if (distance < 0) {
      // targetDate = targetDate.toLocaleString("en-US", {timeZone: "America/Los_Angeles"});
      section.querySelector('#wct_headline').innerText = section.postEventHeading;
      section.querySelector('#wct_subhead').innerText = section.postEventSubheading;
      section.querySelector('#wct_countdown').style.display = 'none';
      section.querySelector('#wct_content').style.display = 'block';
      clearInterval(this.clock);
    }
    //seconds
  }
}

if (!customElements.get('countdown-timer')) customElements.define('countdown-timer', CountdownTimer);
